import React from 'react'

const IncreaseBusiness = () => {
    return (
        <>
            <svg
                width={55}
                height={55}
                viewBox="0 0 512 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M487.01 27.9V249.58L451.62 250.85L416.19 252.18V27.9H487.01ZM263.9 27.9V330.95L193.09 301.83V27.9H263.9ZM375.45 124.87V380.4L355.83 398.55L337.42 415.63L304.64 382.64V124.87H375.45ZM152.3 124.87V313.87L81.5303 296.02V124.87H152.3Z"
                    fill="#3791F4"
                />
                <path
                    d="M487.01 27.9V249.58L451.62 250.85V27.9H487.01ZM263.9 27.9V316.42L228.47 301.83V27.9H263.9ZM375.45 124.87V380.4L355.83 398.55L340.02 382.64V124.87H375.45ZM152.3 124.87V304.94L116.92 296.02V124.87H152.3Z"
                    fill="#54A0FF"
                />
                <path
                    d="M500.42 325.34L498.48 341.6L487.01 329.72L465.29 307.24L416.19 357.25L375.45 398.81L360.41 414.15L334.92 440.1L308.72 414.15L304.64 410.12L263.85 369.8L215.52 321.92L183.25 354.14L176.31 343.44L215.52 304.28L263.85 352.16L304.64 392.48L308.72 396.51L334.92 422.46L360.41 396.51L375.45 381.16L416.19 339.61L465.29 289.6L487.01 312.08L500.42 325.34Z"
                    fill="#FF9F22"
                />
                <path
                    d="M510.92 237.03L498.48 341.6L465.29 307.24L457.33 297.7L416.19 339.61L375.45 381.16L360.41 396.51L334.92 422.46L308.72 396.51L304.64 392.48L263.85 352.16L215.52 304.28L176.31 343.44L163.87 324.17L215.52 272.57L263.85 320.44L304.64 360.77L334.92 390.75L375.45 349.45L416.19 307.9L440.26 283.38L406.35 249.47L416.19 248.3L422.11 247.59L487.01 239.89L510.92 237.03Z"
                    fill="#FFC14F"
                />
                <path
                    d="M190.08 389.53C190.08 434.29 159.03 471.77 117.28 481.56V481.61C111.88 482.88 106.37 483.65 100.71 483.96C100.61 484.01 100.46 484.01 100.3 483.96C98.7199 484.06 97.1898 484.11 95.6098 484.11C82.0998 484.11 69.1998 481.25 57.5798 476.11C24.3398 461.48 1.08984 428.24 1.08984 389.54C1.08984 337.33 43.4098 294.97 95.6098 294.97C97.1898 294.97 98.7699 295.02 100.3 295.07C118.5 295.99 135.38 302 149.45 311.84C166.12 323.41 178.92 340.24 185.39 359.92C188.45 369.23 190.08 379.18 190.08 389.53Z"
                    fill="#F7D33E"
                />
                <path
                    d="M190.08 389.53C190.08 434.29 159.03 471.77 117.28 481.56V481.61C111.88 482.88 106.37 483.65 100.71 483.96C100.61 484.01 100.46 484.01 100.3 483.96C88.6203 483.35 77.5603 480.6 67.3603 476.11C34.0703 461.48 10.8203 428.24 10.8203 389.54C10.8203 339.01 50.4903 297.72 100.3 295.07C118.5 295.99 135.38 302 149.45 311.84C166.12 323.41 178.92 340.24 185.39 359.92C188.45 369.23 190.08 379.18 190.08 389.53Z"
                    fill="#FFDE50"
                />
                <path
                    d="M169.84 389.53C169.84 428.43 139.96 460.4 101.93 463.56C99.8401 463.76 97.7501 463.87 95.6101 463.87C89.0801 463.87 82.8101 463 76.8501 461.47C44.8801 453.16 21.3301 424.1 21.3301 389.53C21.3301 348.49 54.5701 315.2 95.6101 315.2C97.7501 315.2 99.8901 315.3 101.98 315.51C139.96 318.71 169.84 350.63 169.84 389.53Z"
                    fill="#F4AF03"
                />
                <path
                    d="M169.84 389.53C169.84 428.43 139.96 460.4 101.93 463.56C97.6495 463.2 93.5195 462.49 89.5395 461.47C57.5695 453.16 34.0195 424.1 34.0195 389.53C34.0195 350.63 63.8995 318.66 101.98 315.5C139.96 318.71 169.84 350.63 169.84 389.53Z"
                    fill="#FFBD00"
                />
                <path
                    d="M124.659 358.752H112.34C114.123 361.593 115.271 364.802 115.804 368.358H127.939L124.597 381.11H115.681C114.759 386.71 112.607 391.288 109.224 394.843C105.842 398.399 101.046 401.118 94.8149 402.998L119.432 433.101V434H96.6596L68.8243 400.893L68.7628 389.223H83.0699C88.8501 389.101 92.6011 386.403 94.2819 381.131H67L70.3411 368.378H93.8105C92.0272 364.556 88.5632 362.554 83.3774 362.39H67.0615L70.9355 346H128L124.659 358.752Z"
                    fill="white"
                />
            </svg>

        </>
    )
}

export default IncreaseBusiness